import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DisplayedProduct,
  ProductService,
} from '@coworkrz/products/data-access';
import { finalize, map } from 'rxjs';
import {
  BadgeComponent,
  CardComponent,
  CounterComponent,
  PortalButtonComponent,
  SkeletonComponent,
  SliderComponent,
} from '@coworkrz/shared/ui';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroArrowLeft, heroArrowRight } from '@ng-icons/heroicons/outline';
import { hugeShoppingBasketAdd03 } from '@ng-icons/huge-icons';
import { SwiperComponent } from '@coworkrz/shared/ui';
import { RouterModule } from '@angular/router';
import { CurrencyPipe, ImgPlaceholderPipe } from '@coworkrz/shared/misc';
import { ProductUnit } from '@coworkrz/products/types';
import { Price } from '@coworkrz/core/db';
import { RefreshmentCartComponent } from '@coworkrz/refreshments/feature-cart';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { Cart, CartService } from '@coworkrz/carts/data-access';

@Component({
  selector: 'app-refreshment-details',
  imports: [
    CommonModule,
    SliderComponent,
    BadgeComponent,
    CounterComponent,
    PortalButtonComponent,
    NgIconComponent,
    CardComponent,
    SwiperComponent,
    RouterModule,
    SkeletonComponent,
    CurrencyPipe,
    ImgPlaceholderPipe,
    DialogModule,
  ],
  providers: [
    provideIcons({
      heroArrowRight,
      hugeShoppingBasketAdd03,
      heroArrowLeft,
    }),
  ],
  templateUrl: './refreshment-details.component.html',
})
export class RefreshmentDetailsComponent implements OnInit {
  private productService = inject(ProductService);
  dialog = inject(Dialog);
  private cartService = inject(CartService);

  refreshment: DisplayedProduct;
  promotion: number | null;
  size: ProductUnit = ProductUnit.MEDIUM;
  quantity = 1;
  total: number;
  totalItems: 0;
  loadingDetails = false;
  loadingRefreshments = false;
  recommendations: DisplayedProduct[] = [];
  selectedProduct: DisplayedProduct;
  selectedProductPrice: number | null = null;
  filteredRecommendations: DisplayedProduct[] = [];
  ProductUnit = ProductUnit;
  pricesByUnit: { [unit in ProductUnit]?: Price[] } = {}; // Stocker les prix par unité
  cart: Cart = { cartItems: [], totalAmount: 0, totalItems: 0 };

  @Input() set id(id: string) {
    this.loadingDetails = true;
    this.productService
      .getOne(id)
      .pipe(
        map((data) => {
          return this.productService.generateProductBasedOnPrice(data, true);
        }),
        finalize(() => (this.loadingDetails = false))
      )
      .subscribe((data) => {
        this.quantity = 1;
        this.refreshment = data[0];
        this.total = data[0].currentPrice.amount;
        if (data[0].currentPrice.endDate != null) {
          this.promotion = Math.floor(
            (1 - data[0].currentPrice.amount / data[0].normalPrice.amount) * 100
          );
        } else this.promotion = null;
      });
  }

  constructor() {
    this.cartService.cart$.subscribe((cart) => {
      this.cart = cart;
    });
  }

  ngOnInit() {
    this.getRefreshments();
  }
  addToCart(product: DisplayedProduct): void {
    this.cartService.updateItem(product, this.quantity, undefined, true);
  }

  displayCart() {
    this.dialog.open<string | undefined>(RefreshmentCartComponent, {
      minWidth: '300px',
    });
    this.addToCart(this.refreshment);
  }
  private getProduct(category?: string) {
    return this.productService
      .getList({
        category,
      })
      .pipe(
        map((products) =>
          products.flatMap((product) =>
            this.productService.generateProductBasedOnPrice(product)
          )
        )
      );
  }

  getRefreshments(): void {
    this.loadingRefreshments = true;
    this.getProduct('refreshment')
      .pipe(finalize(() => (this.loadingRefreshments = false)))
      .subscribe((data) => {
        this.recommendations = data;
        this.selectSize(this.size);
      });
  }

  getCounterNumber(event: number) {
    this.quantity = event;
    this.total = this.refreshment.currentPrice.amount * this.quantity;
  }

  selectSize(size: ProductUnit) {
    this.size = size;
    // Update price and total when size changes
    const selectedPrice = this.refreshment.prices.find(
      (price) => price.unit === size
    );
    if (selectedPrice) {
      this.total = selectedPrice.amount * this.quantity;
      this.refreshment.currentPrice = selectedPrice;
    }
  }

  hasSize(unit: ProductUnit): boolean {
    return this.refreshment.prices.some((price) => price.unit === unit);
  }
}
